import "./Details.css";

import React, {memo} from "react";

import {CommonAttribute} from "features/validationRules/types";
import AttributeComponent from "./AttributeComponent";

const DocumentAttributesView = ({attributes, docsSet}: { docsSet: string[], attributes: CommonAttribute[] }) => {
    return (
        <>
            {attributes.map(attribute => <AttributeComponent key={attribute.attribute} docsSet={docsSet} attribute={attribute}/>)}
        </>
    );
};

export default memo(DocumentAttributesView);
